/**
 * Author: Andrey Morozov
 * Confidential. Proprietary code. Do not distribute without authorization.
 *
 * feedback.ts — feedback (services/operator-web-app).
 */

/**
 * Feedback and QA API (web-ui backend: POST /api/feedback, POST /api/qa).
 */

import { apiPost } from './client';

export type FeedbackType = 'hint_copied' | 'hint_acknowledged';

export interface FeedbackRequest {
  call_id: string;
  session_id?: string;
  type: FeedbackType;
  hint?: string;
}

export async function sendFeedback(body: FeedbackRequest): Promise<void> {
  await apiPost<unknown>('/api/feedback', body);
}

export async function markCallForQA(callId: string): Promise<void> {
  await apiPost<unknown>('/api/qa', { call_id: callId });
}
